import { render, staticRenderFns } from "./GGInputLabel.vue?vue&type=template&id=3735b454&"
import script from "./GGInputLabel.vue?vue&type=script&lang=js&"
export * from "./GGInputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3735b454')) {
      api.createRecord('3735b454', component.options)
    } else {
      api.reload('3735b454', component.options)
    }
    module.hot.accept("./GGInputLabel.vue?vue&type=template&id=3735b454&", function () {
      api.rerender('3735b454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/Inputs/GGInputLabel.vue"
export default component.exports